<div>
  <div class="ui-fluid">
    <p-table #dt
             [value]="model.rows"
             [globalFilterFields]="filterableColumnKeys"
             [(selection)]="selectedRows"
             selectionMode="multiple"
             [scrollable]="true" 
             [loading]="false"
             [loadingIcon]="null"
             [showLoader]="false"
             [lazy]="true"
             (onLazyLoad)="lazyLoad($event)"
             [paginator]="false"
             [rows]="rows"
             [totalRecords]="rowCount"
             sortMode="multiple"
             [multiSortMeta]="multiSortMeta"
             [resizableColumns]="true"
             columnResizeMode="expand"
             (onRowSelect)="rowChangePreview($event)"
             (onRowUnselect)="rowChangePreview($event)">
      <ng-template pTemplate="header">
        <tr class="order-list-header">
          <th  id="invoice-list-width" [ngClass]="status != 'ready_to_audit' ? 'accounting-list-width' : ''" [attr.width]="rowTools.width" [style.min-width.px]="rowTools.width"></th>
          <th  id="invoice-list-sortable" *ngFor="let col of visibleColumns" [pSortableColumn]="(col.sortable && !isShowCheckBox) ? col.key : null" [class.sort-disabled]="isShowCheckBox || !col.sortable" 
          [style.width.px]="col.width"
          [attr.width]="col.width" [style.min-width.px]="col.width">
            <table>
              <th id="invoice-list-key" class="th-display-none"></th>
              <tbody>
                <tr>
                  <td style="width:22px">
                    <p-sortIconCustom *ngIf="col.sortable === true && !isShowCheckBox" [field]="col.key"></p-sortIconCustom>
                  </td>
                  <td>
                    {{col.name}}
                  </td>
                </tr>
              </tbody>
            </table>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="loadingbody" let-columns>
        <tr>
          <td [attr.colspan]="numColumns" style="text-align: center">
            <loading></loading>Loading...
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="numColumns" style="text-align: center">
            No records found
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item let-i="rowIndex">
        <tr (mouseenter)="hover = item.id"
        [style.background-color]="rowColor(item)"
        (mouseleave)="hover = null">
          <td class="overflow-hidden">
            <div class="bulk-upload-checkbox">
              <p-tableCheckbox *ngIf="isShowCheckBox" [value]="item" [disabled]="item.isBulkUploadInvoiceActive || (item.isEditModeActive && item.editModeActiveBy != userId)"></p-tableCheckbox>
              <!-- <row-tools [tools]="rowTools" [class]="item.colourCode ? 'link-btn' : 'table-order-number'" [item]="item" (onSetRowColour)="setRowColour($event)" (onClick)="clickRowTools($event)" [visible]="hover == item.id"></row-tools> -->
              <row-tools [tools]="rowTools" [item]="item" [class]="item.colourCode ? 'link-btn' : 'table-order-number'"
                (onSetRowColour)="setRowColour($event)" (onClick)="clickRowTools($event)" [visible]="hover == item.id">
              </row-tools>
            </div>
          </td>
          <td *ngFor="let col of visibleColumns">
            <!-- <div tooltipStyleClass="tt-style" [pTooltip]="item.paymentNotes" *ngIf="col.key === 'paymentNotes'">{{item.paymentNotes ? (item.paymentNotes.length>50 ? (item.paymentNotes | slice:0:50)+'...' : item.paymentNotes) : '-'}}</div> -->
            <dynamic-value [data]="item" [column]="col"  [class]="col.key == 'number' && item.colourCode ? 'link-btn' : 'table-order-number'" [items]="lookups[col.lookupKey]"></dynamic-value>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <paginator-custom [rows]="dt.rows" [totalRecords]="dt.totalRecords" (onPageChange)="lazyLoad($event)"></paginator-custom>
  </div>
</div>
<p-dialog [(visible)]="showUserModal" [style]="{width: '100vw',padding:'15px',border:'none',maxHeight:'100%',boxShadow:'none'}" [modal]="true" [showHeader]="false" [closable]="false">
  <user-form *ngIf="showUserModal" [id]="null" (onCancel)="cancel()" (onSaveComplete)="cancel();" ></user-form>
</p-dialog>
<p-dialog styleClass="order-form-width"  #orderDialog [(visible)]="showOrderModal" [style]="{width: '100vw',padding:'15px',border:'none',maxHeight:'100%',boxShadow:'none'}" [modal]="true" [showHeader]="false" [closable]="false" appendTo="body">
  <!-- <order-form *ngIf="showOrderModal" [dialog]="dialogRef" [id]="status == 'complete' ? selection?.id : null" (onCancel)="cancel()" (onSaveComplete)="cancel();"></order-form> -->
  <order-form *ngIf="showOrderModal" [dialog]="dialogRef" [id]="status == 'complete' ? selection?.guid : invoiceOrderNumber" (onCancel)="cancel($event)" (onSaveComplete)="cancel($event);" (onRevert)="revert($event)"  [navigateOnSave]="false" class="order-form-alignment"></order-form>
</p-dialog>
<p-dialog #locationDialog [(visible)]="showLocationModal" [style]="{width: '100vw',padding:'15px',border:'none',maxHeight:'100%', boxShadow:'none'}" [modal]="true" [showHeader]="false" [closable]="false" appendTo="body">
  <location-form *ngIf="showLocationModal" [id]="null" (onCancel)="cancel()"></location-form>
</p-dialog>
<p-dialog *ngIf="showAccountingBulkEditModal"  [(visible)]="showAccountingBulkEditModal" styleClass="p-dialog-width-bulkupload bulk-upload-window" [modal]="true" [showHeader]="false" [closable]="false" appendTo="body">
  <accounting-dynamic-bulk-upload [invoices]="selectedRows" (onCancel)="cancel($event)" (onSaveComplete)="save($event)"></accounting-dynamic-bulk-upload>
</p-dialog>
